import { PHONE_NUMBER_DIGITS_COUNT } from './phone';

export const PHONE_NUMBER_TEST_REGEXP = new RegExp(`^\\+(\\d){${PHONE_NUMBER_DIGITS_COUNT}}$`);
